<template>
    <div class="filtersHandler">
        <b-input-group class="classic-input-group">
            <template v-if="!noSearch" #append>
                <b-button variant="outline-primary" v-if="workingValue.term" @click="workingValue.term = ''; applyValue()">
                    <span class="fa fa-times"></span>
                </b-button>
                <b-button variant="outline-primary" @click="applyValue">
                    <span class="imoon-search2"></span>
                </b-button>
            </template>
            <b-form-input v-if="!noSearch" v-model="workingValue.term" :placeholder="filterPlaceholder" @input="applyValue"></b-form-input>
        </b-input-group>
        <div class="inner">
            <slot name="default"></slot>
        </div>
        <b-pagination v-model="workingValue.page" 
            :total-rows="itemsCount" 
            :per-page="perPage" 
            @input="applyValue"
            align="center" />
    </div>
</template>

<script>

const defaultValue = {
    term: '',
    page: 1
};

export default {
    name: 'filtersHandler',
    props: {
        noSearch: {
            type: Boolean,
            default: false
        },
        enableRoutingUpdate: {
            type: Boolean,
            default: true
        },
        filterPlaceholder: {
            type: String,
            default: 'Buscador...'
        },
        perPage: {
            type: Number,
            default: 10
        },
        itemsCount: {
            type: Number,
            default: 0
        },
        value: {
            type: Object,
            default: () => defaultValue
        }
    },
    data: () => ({
        workingValue: { ...defaultValue }
    }),
    methods: {
        applyValue() {
            this.$emit('input', this.workingValue);
            this.applyRouteUpdate()
        },
        applyRouteUpdate() {
            if (this.enableRoutingUpdate && this.$route) {
                const params = { ...this.workingValue };
                // Remove empty params
                Object.keys(params).forEach(key => {
                    if (params[key] === '' || params[key] === null || params[key] === undefined) {
                        delete params[key];
                    }
                });
                this.$router.push({ name: this.$route.name, params });
            }
        }
    },
    beforeMount() {
        if (this.$route && this.$route.params) {
            this.workingValue = { ...this.$route.params, ...defaultValue };
        } else if(this.value) {
            this.workingValue = { ...this.value, ...defaultValue };
        }
        this.$emit('input', this.workingValue);
    },
};
</script>

<style lang="scss">
@import '@/sass/utils/variables.scss';

.filtersHandler {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: end;
    width: 100%;
    gap: 2em;
    border: $primary-dark-border;
    border-radius: 0.5em;
    padding: 0.5em;
    margin: 0 1em ;

    .inner {
        flex: 1 0 auto;
    }

    @media screen and (max-width: 768px) {
        flex-flow: column;
        // align-items: center;
        gap: 0.5em;
    }

    .classic-input-group {
        min-width: 9em;
        display: flex;
        flex-flow: row nowrap;
        .form-control,
        .input-group {
            width: auto;
        }
    }

    .pagination {
        display: flex;
        justify-content: center;
        margin: 0;
        padding: 0;
        border: $primary-dark-border;

        .page-item {

            span,
            button {
                background-color: $primary-dark;

                &:disabled {
                    opacity: 0.5;
                }
            }
        }
    }
}
</style>